<template>
  <v-flex class="cStatement" data-qa="localpaymentsreview-flex-b0ltne">
    <div class="transferReview" data-qa="localpaymentsreview-div-lyyl4a">
      <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="localpaymentsreview-layout-z9nnz">
        <v-flex
          xs12
          sm12
          md12
          lg12
          xl12
          :style="{ background: dashboardGradient, height: '180px' }"
         data-qa="localpaymentsreview-flex-dbqmyx">
          <v-container class="transferFunds--title-padding" data-qa="localpaymentsreview-container-ykx06v">
            <v-flex xs12 sm12 md12 lg12 xl12 data-qa="localpaymentsreview-flex-byejf">
              <v-row no-gutters data-qa="localpaymentsreview-row-zrcrf">
                <v-layout row wrap class="pb-2" data-qa="localpaymentsreview-layout-f8jjhu">
                  <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="localpaymentsreview-flex-pkr55cb">
                    <v-row justify="end" data-qa="localpaymentsreview-row-h7mtel">
                      <v-avatar :tile="false" size="35" color="white" data-qa="localpaymentsreview-avatar-1593n">
                        <v-icon :color="this.primaryColor" data-qa="localpaymentsreview-icon-zbnjek">mdi-sync</v-icon>
                      </v-avatar>
                    </v-row>
                  </v-flex>
                  <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="localpaymentsreview-flex-beo8i">
                    <v-row no-gutters data-qa="localpaymentsreview-row-tk8mce">
                      <font class="text-h5 font-weight-light white--text">
                        {{ $t("localPayments.title") }}</font
                      >
                    </v-row>
                  </v-flex>
                </v-layout>
              </v-row>
            </v-flex>
          </v-container>
        </v-flex>
      </v-layout>

      <v-flex
        xs12
        sm12
        md12
        lg10
        xl10
        class="pl-12 cStatement--overlayCardFlex"
       data-qa="localpaymentsreview-flex-e7qqme">
        <v-layout row wrap class="pl-12" data-qa="localpaymentsreview-layout-fg56lw">
          <v-flex xs12 sm12 md12 lg10 xl10 class="pt-4" data-qa="localpaymentsreview-flex-z0s2ur">
            <v-card data-qa="localpaymentsreview-card-8f892j">
              <v-card-text class="text--primary" data-qa="localpaymentsreview-card-text-n8nvpj">
                <v-row no-gutters class="py-2" data-qa="localpaymentsreview-row-mjjcnk">
                  <DisplayDetails
                    :config="{
                      title: `Summary`,
                      dataList: summaryDetails
                    }"
                    class="pl-6"
                  />
                </v-row>
              </v-card-text>

              <v-card-actions class="pl-8 pt-3 pb-8" data-qa="localpaymentsreview-card-actions-66ugk">
                <v-layout wrap data-qa="localpaymentsreview-layout-ebb7qg">
                  <v-btn
                    @click="goBack"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    outlined
                    class="text-capitalize ma-2 pl-10 pr-10 py-2 px-4"
                   data-qa="localpaymentsreview-btn-krarhg">
                    {{ $t("transferfunds.backButton") }}
                  </v-btn>
                  <v-btn
                    @click="confirmTransfer"
                    :color="primaryColor"
                    :disabled="disableBtn"
                    class="text-capitalize ma-2 pl-16 pr-16 white--text py-2 px-4"
                   data-qa="localpaymentsreview-btn-iq6ogw">
                    {{ $t("transferfunds.confirmButton") }}
                  </v-btn>
                </v-layout>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- OTP -->
      <Modal
        v-if="enableOTP && showOTPScreen"
        @cancel="onOtpModalClose"
        :config="modalConfig.otp"
      >
        <span slot="modalContent" data-qa="localpaymentsreview-span-fpci6i">
          <OtpInput :otpConfig="otpSettings" />
        </span>
      </Modal>
      <DownloadPaymentProof v-show="showDownloadPayment" :config="paymentProofDetails"></DownloadPaymentProof>
      <Modal 
          v-if="showSuccessDialog" 
          :config='getPaymentSuccessDialogConfig'
          @btn1Action="handleCreateNewTransfer"
          @btn2Action="handleGotoDashboard"
          @btn3Action="downloadPaymentProofEnabled"
      >
        </Modal>
      <PaymentFailureDialog
        :show="failureDialog.show"
        :retry="false"
        :error-list="failureDialog.errorList"
        @goBack="handleGoBack"
        @cancelTransfer="handleCancelTransfer"
      />
    </div>
  </v-flex>
</template>

<script>
import '@/styles/pages/consolidatedStatement.scss'
import '@/styles/pages/transferFunds.scss'
import commonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import DisplayDetails from '@/views/common/DisplayDetails.vue'
import event from '@/util/event'
import { unflatten } from 'flat'
import preload from '@/util/preload'
import PaymentSuccessDialog from '../common/PaymentSuccessDialog.vue'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import { formatSelectedAccount, formatSelectedHint } from '@/util/accountUtil.js'
import DownloadPaymentProof from '@/views/payments/paymentProof/PaymentProofFormat.vue'

export default {
  name: 'LocalPaymentsReview',
  props: {
    config: {
      type: Object,
      default: undefined
    }
  },
  components: {
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput,
    DisplayDetails,
    PaymentSuccessDialog,
    PaymentFailureDialog,
    DownloadPaymentProof
  },
  data () {
    return {
      showSuccessDialog: false,
      successResponse: '',
      failureResponseAPI: '',
      payload: {},
      reqBody: {},
      confirmData: {},
      disableBtn: false,
      summaryDetails: [],
      enableOTP: this.$appSettings.defaultConfigurations.localPayments.enableOTP,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      showOTPScreen: false,
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        },
        successModal: {
          persistent: true,
          title: this.$t('localPayments.label.transferSuccess'),
          btn1Label: this.$t('paymentSuccessDialog.button.newTransfer'),
          btn2Label: this.$t('paymentSuccessDialog.button.gotoDashboard'),
          width: 700
        }
      },
      failureDialog: {
        show: false,
        errorList: [],
        retryCount: 0
      },
      showDownloadPayment: false,
      paymentProofDetails: {},
      downloadDataDetails: [],
      proofOfPaymentConfiguration: this.$appSettings.defaultConfigurations.proofOfPayment,
      isDownloadPaymentProofEnabled: this.$appSettings.defaultConfigurations.proofOfPayment.enableProofOfPaymentDownload
    }
  },
  created () {
    this.setSummaryData()
    this.payload = this.config.payload
    this.reqBody = unflatten(this.config.unflattenBody)
    if (this.config?.charges) {
      this.reqBody.initiationContext.preCalculatedCharges.amount = this.config.charges.amt
    }
    event.$on('IS_OTP_VALID', (val) => {
      this.modalConfig.otp.enabled = true
      this.iniateLocalPaymentTransfer()
    })
    if (this.isDownloadPaymentProofEnabled) {
      this.modalConfig.successModal.btn3Label = this.$t('paymentSuccessDialog.button.download')
    }
  },
  computed: {
    resource () {
      return {
        yourReference: this.$t('swiftPayments.yourReference'),
        transferSuccess: this.$t('localPayments.label.transferSuccess')
      }
    },
    getPaymentSuccessDialogConfig () {
      return {
        ...this.modalConfig.successModal,
        enabled: this.showSuccessDialog,
        dataDetails: this.summaryDetails,
        body: this.$t('swiftPayments.yourReference') + ' ' + this.confirmData?.referenceID
      }
    }
  },
  methods: {
    setSummaryData () {
      this.downloadDataDetails = []
      const { model, schema } = this.config.payload
      this.summaryDetails = Object.keys(model)
        // TODO: check model why there is an undefined field
        .filter(key => key !== 'undefined' && !schema[key].hidden)
        .map(key => ({
          label: schema[key].label,
          value: model[key]
        }))
      
      this.downloadDataDetails.push(
        {
          label: 'amount',
          value: this.$formatter.currency.format(model?.amount, model?.currency)
        },
        {
          label: 'paymentDate',
          value: this.$formatter.formatDate(model?.transactionDate)
        }
      )
      this.summaryDetails.push({
        label: this.$t('localPayments.label.charges'),
        value: this.config.charges.amt
      })
      this.downloadDataDetails.push({
        label: 'charges',
        value: this.$formatter.currency.format(this.config?.charges?.amt, model?.currency)
      })
      if (this.config.bankIdType === 'PROPRIETARY') {
        this.summaryDetails.unshift({
          label: this.$t('localPayments.label.selectPayee'),
          value: this.config.beneName + ' (' + this.config.accIdentification + ')'
        })
        this.downloadDataDetails.unshift({
          label: 'toAcc',
          value: this.config?.beneName + ' (' + this.config?.accIdentification + ')'
        })
      } else {
        this.summaryDetails.unshift({
          label: this.$t('localPayments.label.selectPayee'),
          value: this.config.beneName,
          subValue: this.config.beneId
        })
        const beneficiaryDetails = this.config.beneId.split('')
        this.downloadDataDetails.unshift({
          label: 'toAcc',
          value: this.config?.beneName,
          subValue: `${this.$formatter.maskNumber(beneficiaryDetails[0])} ${beneficiaryDetails[1]}`
        })
      }
      this.summaryDetails.unshift({
        label: this.$t('localPayments.label.sourceAccount'),
        value: formatSelectedAccount(this.config.fromAccDetails),
        subValue: formatSelectedHint(this.config.fromAccDetails)
      })
      this.downloadDataDetails.unshift({
        label: 'fromAcc',
        value: formatSelectedAccount(this.config?.fromAccDetails),
        subValue: this.$formatter.maskNumber(formatSelectedHint(this.config?.fromAccDetails)?.split(' ')[0])
      })
    },
    handleCreateNewTransfer () {
      this.showSuccessDialog = false
      this.$emit('refreshAccounts')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
    },
    handleGotoDashboard () {
      this.showSuccessDialog = false
      event.$emit('localPaymentTransferComplete', true)
      this.loaderEnabled = true
      preload.getListOfAccounts(JSON.parse(sessionStorage.getItem('username')))
      this.$router.push('/home')
    },
    handleGoBack () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
    },
    handleCancelTransfer () {
      this.failureDialog.show = false
      this.$emit('refreshAccounts')
      event.$emit('IS_REVIEW_CLEAR', { type: 'Reset' })
      this.failureDialog.errorList = []
    },
    handleErrors (errors) {
      this.failureDialog.show = true
      if (errors.length) {
        errors.forEach(error => {
          if (error.message) {
            this.failureDialog.errorList.push(error.message)
          }
        })
      } else this.failureDialog.errorList = []
    },
    onOtpModalClose () {
      this.modalConfig.otp.enabled = false
      this.disableBtn = false
      this.showOTPScreen = false
    },
    confirmTransfer () {
      this.disableBtn = true
      if (this.enableOTP) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.iniateLocalPaymentTransfer()
      }
    },
    goBack () {
      event.$emit('IS_REVIEW_CLEAR', { type: 'GoBack' })
    },
    downloadPaymentProofEnabled () {
      let dataDetails = []
      const exclusionList = this.proofOfPaymentConfiguration.exclusionList
      dataDetails = this.downloadDataDetails?.filter(item => !exclusionList.includes(item.label))
      let titleContentDetails = [
        { label: this.$t('proofOfPayment.label.transactionRef'), value: this.confirmData?.referenceID },
        { label: this.$t('proofOfPayment.label.transactionStatus'), value: this.$t('proofOfPayment.value.processing') }
      ]
      this.paymentProofDetails = {
        dataDetails,
        titleContentDetails,
        dataListTranslation: 'proofOfPayment.label',
        title: this.$t(this.proofOfPaymentConfiguration.payment_title),
        subTitle: this.$t(this.proofOfPaymentConfiguration.payment_subTitle, { transactionId: this.confirmData?.referenceID }),
        contentTitle: this.$t(this.proofOfPaymentConfiguration.payment_contentTitle),
        transactionId: this.confirmData?.referenceID
      }
      event.$emit('download_payment_proof', this.paymentProofDetails)
    },
    async iniateLocalPaymentTransfer () {
      const response = await commonService.initiateLocalPaymentTransfer(this.reqBody)
      if (response && !response.causes && response.document) {
        this.setConfirmationInfo(response.document)
      }
      if (response && response.data && response.data.message && (response.data.status === 400)) {
        this.failureResponseAPI = response?.causes ? response.causes : ''
        this.handleErrors(this.failureResponseAPI)
      }
      if (response && response.internalType === 'OTP-ERROR') {
        event.$emit('otp_validation_failed', response)
      }
    },
    async setConfirmationInfo (info) {
      this.confirmData = {
        referenceID: info.cstmrPmtStsRpt.grpHdr.msgId
      }
      this.showSuccessDialog = true
      this.onOtpModalClose()
      this.successResponse = this.confirmData
      event.$emit('localPaymentTransferComplete', true)
    }
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTP && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeDestroy () {
    event.$off('IS_OTP_VALID')
    event.$off('download_payment_proof')
  }
}
</script>
